/**
 * @generated SignedSource<<2acdf9fc59bf8abcc3d08c233264a644>>
 * @relayHash ffcb9a87fb8d04534e382c73454b844e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0f3d803a6a35f256abed61f3a88c98dbe9083a5e7f262f6bc862cbb76425f9e0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery } from './uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery.graphql';

const node: PreloadableConcreteRequest<uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0f3d803a6a35f256abed61f3a88c98dbe9083a5e7f262f6bc862cbb76425f9e0",
    "metadata": {},
    "name": "uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
